<template>
  <div class="upload-section">
    <h3>{{ title }}</h3>
    <div class="file-upload">
      <div
        class="file-upload-container"
        :class="{ 'drag-over': isDragOver }"
        @dragover.prevent="handleDragOver"
        @dragenter.prevent="handleDragEnter"
        @dragleave.prevent="handleDragLeave"
        @drop.prevent="handleDrop"
      >
        <label class="file-upload-button outlined">
          <span class="icon">
            <svg><use xlink:href="#icon-upload"></use></svg>
          </span>
          <span>{{ $t('forwarders.chooseFile') }}</span>
          <input 
            type="file" 
            :name="osType" 
            class="hidden-input" 
            @change="handleFileSelected"
          >
        </label>
        <span class="or-text">{{ $t('forwarders.dragDropFile') }}</span>
      </div>
    </div>
    <div v-if="selectedFile" class="file-selected">
      <div class="file-icon">
        <span class="icon">
          <svg><use xlink:href="#icon-file-archive"></use></svg>
        </span>
      </div>
      <div class="file-info">
        <div class="file-name">{{ selectedFile.name }}</div>
        <div class="file-status">
          <span class="success-icon">
            <svg><use xlink:href="#icon-check"></use></svg>
          </span>
          {{ $t('forwarders.uploadSuccess') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadSection',
  props: {
    title: {
      type: String,
      required: true
    },
    osType: {
      type: String,
      required: true
    },
    selectedFile: {
      type: Object,
      default: null
    },
    isDragOver: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleFileSelected(event) {
      this.$emit('file-selected', event, this.osType)
    },
    handleDragOver(event) {
      this.$emit('drag-over', event, this.osType)
    },
    handleDragEnter(event) {
      this.$emit('drag-enter', event, this.osType)
    },
    handleDragLeave(event) {
      this.$emit('drag-leave', event, this.osType)
    },
    handleDrop(event) {
      this.$emit('drop', event, this.osType)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-section {
  background-color: #40424a;
  border-radius: 8px;
  padding: 0.75rem;
  height: calc(1.5 * (130px)); /* Increase height by 1.5x */
  display: flex;
  flex-direction: column;

  h3 {
    color: #fff;
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
  }
}

.file-upload {
  margin-bottom: 0.75rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  .file-upload-container {
    display: flex;
    align-items: center;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 0.5rem;
    background-color: #2a2d36;
    transition: all 0.3s ease;

    &.drag-over {
      border-color: #4A69FF;
      background-color: rgba(74, 105, 255, 0.1);
      border-width: 2px;
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(74, 105, 255, 0.3);
    }
  }

  .file-upload-button {
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    &.outlined {
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 4px;
      padding: 0.25rem 0.5rem;;
      color: #fff;
      background-color: #1b1c3c;

      .icon {
        margin-right: 0.5rem;

        svg {
          fill: currentColor;
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .or-text {
    color: rgba(255, 255, 255, 0.6);
    margin-left: 0.75rem;
    font-size: 0.85rem;
  }

  .hidden-input {
    display: none;
  }
}

.file-selected {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 0.5rem;
  border-radius: 8px;

  .file-icon {
    margin-right: 0.75rem;
    color: #FFC107;

    svg {
      fill: currentColor;
      width: 20px;
      height: 20px;
    }
  }

  .file-info {
    flex: 1;

    .file-name {
      color: #fff;
      margin-bottom: 0.25rem;
      border-color: transparent;
      border-style: solid;
      border-width: 0px 0px 0px 0px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .file-status {
      color: #4CAF50;
      font-size: 0.8rem;
      display: flex;
      align-items: center;

      .success-icon {
        margin-right: 0.25rem;
        display: flex;
        align-items: center;

        svg {
          fill: currentColor;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
</style>
